/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"
import constantName from "./key"

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}


//Instructions API list
/**
 *
 * @param {integer} id
 * @returns
 */

export function loadInstructions(Id) {
 // let payload = {leadId:id}
 
  return api
    .post(`/get_lead_event_service_list_for_ec`,Id)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export async function createInstruction(specialInstructions) {
  console.log("inside api call------------", specialInstructions)
  try {
    const response = await api.post(
      `/add_lead_quotation_${atob(constantName)}`,
      specialInstructions
    )
    console.log(response.data, "response data from api call")
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function updateInstruction(specialInstructions) {
  try {
    const response = await api.post(
      `/update_lead_quotation_${atob(constantName)}`,
      specialInstructions
    )
    console.log(response.data, "response updated data")
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function deleteInstruction(id, instructionsId) {
  const payload = {
    leadId: id,
    leadQuotationSpecialInstructionId: instructionsId,
  }
  return api
    .post(`/delete_lead_quotation_${atob(constantName)}`, payload)
    .catch((error) => Promise.reject(error))
}





const remotes = {
  loadRecordsMetaData,
  
  loadInstructions,
  createInstruction,
  updateInstruction,
  deleteInstruction,

}

export default remotes
